import React, { ChangeEvent } from "react";
import { Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { useForm } from "../../../../../provider/Form/FormProvider";
import NumberFieldConfigured from "../../../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import ValidatorTextField from "../../../../FormFields/ValidatorTextField";
import { isRequired, requiredValidator } from "../../../../../services/validationRules";
import ValidatorSelectField from "../../../../FormFields/ValidatorSelectField";
import MenuItem from "@mui/material/MenuItem";
import { translate } from "../../../../../services/translations/translations";

export type Item = { key: string; category: string | null; name: string; monthlyAmount: string };

type AlimonyExpensesProps = {
  product: AbstractCase;
  personType: string;
};

export default function AlimonyExpenses({ product, personType }: AlimonyExpensesProps) {
  const { values, handleChange } = useForm();

  const key = () => Math.random().toString(36).slice(2, 11);
  const items = (values?.[personType]?.expensesList ?? []) as Item[];

  const updateItems = (next: Item[]) => {
    const e = {
      target: { name: `${personType}.expensesList`, value: next },
    } as unknown as ChangeEvent<HTMLInputElement>;
    handleChange(e);
  };

  const handleAdd = () => {
    updateItems([...(items || []), { key: key(), category: null, name: "", monthlyAmount: "" }]);
  };

  const handleRemoveLast = () => {
    if (!items?.length) return;
    updateItems(items.slice(0, -1));
  };

  return (
    <>
      <Stack spacing={2} sx={{
        alignItems: "stretch"
      }}>
        {items.map((item: Item, index) => (
          <Stack key={item.key} spacing={1}>
            <ValidatorSelectField
              label={`Kategorie Position ${index + 1}`}
              name={`${personType}.expensesList[${index}].category`}
              validators={[{ validator: isRequired, message: "Bitte geben Sie die Kategorie der Ausgabe an." }]}
            >
              <MenuItem value={"debtRepayment"}>{translate("alimony.expensesCategory.debtRepayment", product)}</MenuItem>
              <MenuItem value={"insurer"}>{translate("alimony.expensesCategory.insurer", product)}</MenuItem>
              <MenuItem value={"privatePension"}>{translate("alimony.expensesCategory.privatePension", product)}</MenuItem>
              <MenuItem value={"visitationCosts"}>{translate("alimony.expensesCategory.visitationCosts", product)}</MenuItem>
              <MenuItem value={"other"}>{translate("alimony.expensesCategory.other", product)}</MenuItem>
            </ValidatorSelectField>

            <ValidatorTextField
              name={`${personType}.expensesList[${index}].name`}
              label={`Beschreibung Position ${index + 1}`}
              validators={[requiredValidator("Bitte geben sie eine Beschreibung die Position an.")]}
            />

            <NumberFieldConfigured
              caseData={product}
              fieldPath={`${personType}.expensesList[${index}].monthlyAmount`}
              fieldType="money"
              numberType="float"
              customLabel={`Monatlicher Betrag Position ${index + 1}`}
              validators={[requiredValidator("Bitte geben sie einen monatlichen Betrag für die Position an.")]}
            />
          </Stack>
        ))}

        {items.length > 0 && (
          <Stack sx={{
            alignItems: "center"
          }}>
            <Button variant="text" sx={{ color: "secondary.dark", px: 3 }} onClick={handleRemoveLast}>
              Position {items.length} entfernen
            </Button>
          </Stack>
        )}

        <Stack sx={{
          alignItems: "center"
        }}>
          <Button sx={{ px: 3 }} variant="contained" color="primary" onClick={handleAdd}>
            Kostenposition hinzufügen
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
